import { AnyObj, FeatureFlagsResponse } from '@indeed/flex-feature-flags'
import { handleCall, reqDefaults } from 'syft-acp-core/api/call'

type FeatureValuesResponse = {
  payload: FeatureFlagsResponse<AnyObj>
}

export const fetchEnabledFeatures = (
  url: string,
  options: RequestInit,
): Promise<FeatureFlagsResponse<AnyObj>> =>
  new Promise(async (resolve, reject) => {
    const headers = reqDefaults()
    const req = new Request(url, { ...headers, ...options })

    handleCall(
      req,
      ({ payload }: FeatureValuesResponse) => resolve({ features: payload.features }),
      reject,
      false,
      false,
      null,
    )
  })
